import * as index from '@syncfusion/ej2-circulargauge';
index.CircularGauge.Inject( index.GaugeTooltip,index.Annotations,index.Legend);
export * from '@syncfusion/ej2-circulargauge';
